import React from 'react'

import { getIntegrationDisplayName, IntegrationServiceId } from '../../common/integrations'

import { IntegrationIcon } from '../IntegrationIcon'
import { Tooltip } from '../Tooltip/Tooltip'
import { Button } from '../Button/Button'

interface ContactUpdateButtonProps {
  serviceId: string
  onClick: () => void
  showTitle?: boolean
  className?: string
  tooltipTitle?: string
}

export const IntegrationExportButton: React.FC<ContactUpdateButtonProps> = ({ serviceId, onClick, showTitle = false, className = '', tooltipTitle = null }) => {
  const integrationDisplayName = getIntegrationDisplayName(serviceId as IntegrationServiceId)
  const title = `Save to ${integrationDisplayName}`

  return (
    <Tooltip key={serviceId} className='paragraph-small' title={tooltipTitle ?? title} placement='top' offset={[0, 10]}>
      <Button className={`px-2 button-large d-flex align-items-center gap-2 ${className}`} variant='header' onClick={onClick}>
        <IntegrationIcon serviceId={serviceId as IntegrationServiceId} className='crm-icon' fill='var(--zocks-gray-900)' />
        {showTitle ? <span>{title}</span> : null}
      </Button>
    </Tooltip>
  )
}
